<script setup lang="ts">
import { router, usePage } from '@inertiajs/vue3'
import { useFavicon } from '@vueuse/core'
import { computed, onUnmounted } from 'vue'
import { useAnalytics } from '~/composables/useAnalytics'
import { useFlash } from '~/composables/useFlash'
import { PageProps } from '~/types/inertia'

const page = usePage<PageProps>()

// A distinct favicon color per non-prod environment so tabs are easy to tell
// apart at a glance; production keeps the static /favicon.svg from the layout,
// which follows the browser's light/dark scheme rather than the app's.
const environmentFavicons: Partial<Record<PageProps['environment'], string>> = {
  development: '/images/favicon/development.svg',
  staging: '/images/favicon/staging.svg'
}

useFavicon(computed(() => environmentFavicons[page.props.environment]))

useFlash()

const { track } = useAnalytics()
const stopTrackingPageViews = router.on('navigate', (event) => {
  track('app_page_viewed', { page_name: event.detail.page.component })
})

onUnmounted(stopTrackingPageViews)

router.on('start', (event) => {
  if (event.detail.visit.url.href.includes('switch')) {
    router.flushAll()
  }

  if (event.detail.visit.url.href.includes('sign_out')) {
    router.clearHistory()
  }
})
</script>

<template>
  <UApp :toaster="{ expand: false, progress: false }">
    <slot />
  </UApp>
</template>
